var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-range-picker',{attrs:{"dates":_vm.dates,"label":"Picker","errors":"''"},on:{"updated":_vm.setDate,"save":_vm.sendData}})}
var staticRenderFns = []

export { render, staticRenderFns }